import { ContentSource } from "../types";
import { canBeMultipleChoiceTested, canBeWordfillTested } from "./utils";

export function canBeTested(source: ContentSource) {
  return canBeMultipleChoiceTested(source) || canBeWordfillTested(source);
}
